import { centsToFixedDollars } from './formatters'

export const transformCharityOptions = (charityOptions) => {
  if (!charityOptions || charityOptions.length === 0) {
    return []
  }

  return charityOptions.map((option) => {
    let id = option?.price || option?.title
    if (option?.isCustom === 'true' || option?.isCustom === true) {
      id = 'custom'
    }

    return {
      id: id,
      title: option?.title || `${centsToFixedDollars(option?.price)}`,
      amount: parseInt(option?.price) || null,
      isCustom: option?.isCustom,
    }
  })
}

export const getNextDollar = (amountInCents) => {
  const nextDollar = Math.ceil((amountInCents + 1) / 100) * 100

  if (nextDollar - amountInCents === 100) {
    return 0
  }

  return nextDollar - amountInCents
}
